import classNames from "classnames";
import styles from "./Input.module.scss";

export const Input = ({ placeholder, className, ...rest }) => (
  <input
    className={classNames(styles.root, className)}
    type="text"
    placeholder={placeholder ? placeholder : "Type something here..."}
    {...rest}
  />
);
